export enum EvaluativeTypes {
    'Peso' = 1,
    'Qualidade' = 2,
    'Emojis' = 3
}

export enum EvaluativeTypesTranslation {
    'weight' = 1,
    'quality' = 2,
    'Emojis' = 3
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/evaluative-type.ts